import { ServiceRequest } from "../types/service.type";
import { ServiceRequestTypeEnum } from "../enum/service.enum";
import { useUserDataFormatter } from "../../User/hooks/useUserDataFormatter";

export const useRequestUserData = (request: ServiceRequest) => {
  const { requester, serviceProvider, type } = request;

  const userToDisplay = type === ServiceRequestTypeEnum.ordered ? serviceProvider : requester;

  return useUserDataFormatter(userToDisplay);
};
